import {
  Box,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Button,
  Paper,
} from '@mui/material'

const ExpensesOverview = ({ expensesKeys, handleKeyClick }) => {
  if (!expensesKeys || !Array.isArray(expensesKeys)) {
    return (
      <div
        style={{
          minHeight: '200px',
          background: 'white',
          fontSize: '24px',
          justifyContent: 'center',
          verticalAlign: 'middle',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        Probléme lors du chargements des données de RGDD...
      </div>
    )
  }

  const styleCell = { fontWeight: 'bold', color: '#183a60' }

  const onClickKey = (index) => {
    const clickedKey = expensesKeys[index].id
    handleKeyClick(clickedKey)
  }

  return (
    <TableContainer
      component={Paper}
      style={{ padding: '20px', paddingLeft: '5%', paddingRight: '5%' }}
    >
      <Box sx={{}}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{}}></TableCell>
              <TableCell style={{ width: '20%' }}></TableCell>
              <TableCell style={{ width: '20%' }}></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {expensesKeys.map((row, index) => (
              <TableRow
                key={`${row.name}-${row.totalExpenses}`}
                onClick={() => onClickKey(index)}
                sx={{
                  '&:hover': { backgroundColor: '#e1e1e1' },
                  cursor: 'pointer',
                }}
              >
                <TableCell style={{ ...styleCell, fontSize: '18px' }}>
                  {row.name}
                </TableCell>
                <TableCell
                  style={{ ...styleCell, textAlign: 'right', fontSize: '20px' }}
                >
                  {new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                    color: '#183a60',
                  }).format(row.totalExpenses / 100)}
                </TableCell>
                <TableCell
                  style={{ ...styleCell, textAlign: 'right', fontSize: '20px' }}
                >
                  {new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                  }).format(row.totalProducts / 100)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  )
}

export default ExpensesOverview
